import { controls, currencyToNumber, grouped } from "../../controls";

const tgc_consolidated = {
  label: "Track The Girl Child Consolidated Report",
  starting: true,
  url: "dept_emp_bill",
  pageLabel: "Track The Girl Child Consolidated Report",
  pageType: "history",
  filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Child Status" }),
    ...controls.autoComplete({ tab: "filter", name: "child_status_code", width: "col-sm-4", controlType: "ChildStatus" }),
    ...grouped.getFromDB('action'),


  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Track The Girl Child Consolidated Report",
    filterable: true,
    sortable: true,
    pivotable: true,
    //defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
    },
    // pivot: true,
    extraRows: {
      location: "top",
      fields: [],
      subtotals: {
        by: "taluka_display",
        displayIn: "village_display",
      },
      grandtotal: { type: "fixed", displayIn: "employee_display", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "village",
        accessor: "village_display"
      },

      {
        Header: "Name",
        accessor: "name",
        rwidth: "*",

      },
      {
        Header: "Fathers Name",
        accessor: "fathers_name",
      },
      {
        Header: "Mothers Name",
        accessor: "mothers_name",
      },
      {
        Header: "Date Of Birth",
        accessor: "date_of_birth",
        type: "date"

      },
      {
        Header: "Contact Number",
        accessor: "contact_number",
      },
      {
        Header: "Child Status Display",
        accessor: "child_status_display",
      },





    ]
  }
};

export default tgc_consolidated;